module.exports = __webpack_public_path__ + "img/finding-us-01.cb79d759.png";